import React from 'react';
var IdSetter = function IdSetter(props) {
  var value = props === null || props === void 0 ? void 0 : props.value;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      '-webkit-user-select': 'text'
    }
  }, value);
};
export default IdSetter;